<template>
    <BasePanel
        :headline="getPanelHeader(subcatalogue).toUpperCase()"
        :alvqa="alvqa"
        :onOpenPanel="onOpenPanel"
    >
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                :items="works"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
                :page.sync="currentPage"
                :server-items-length="totalRecords"
                :loading="isLoading"
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                id="listPage"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <PublishingContractsSubCataloguesEditPanelTopSlot :subcatalogue="subcatalogue" />
                </template>
            <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-title'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.workId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-work-id'">
                        {{ item.gemaNumber }}
                    </div>
                </template>
                <template v-slot:[`item.composers`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.composers.join(' / ')"
                            :alvqa="alvqa + '-list-row-text-main-composer'"
                        />
                    </div>
                </template>
            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
            </v-data-table>
            <v-pagination   
                v-if="numberOfPages > 1"
                total-visible="10" 
                v-model="currentPage" 
                :length="numberOfPages"
                color="pagination"
                @input="nextPage()"
            ></v-pagination>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from '@/components/_buttons/BaseButton'
import PublishingContractsSubCataloguesEditPanelTopSlot from './PublishingContractsSubCataloguesEditPanelTopSlot'

export default {
    name: "PublishingContractsSubCataloguesEditPanel",
    components: {
        BasePanel,
        BaseIcon,
        BaseTooltip,
        BaseButton,
        PublishingContractsSubCataloguesEditPanelTopSlot
    },
    props: {
        subcatalogue: Object
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-subcatalogues'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE"), 
                    align: "left", 
                    value: "title",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_WORK_ID"), 
                    align: "left", 
                    value: "workId",
                    class: 'text-no-wrap',
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-work-id'
                },
                {
                    text: this.$t("lang_PUBLISHING_CAPTION_COMPOSERS"), 
                    align: "left", 
                    value: "composers",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-main-composer'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },
        works() { return this.$store.getters.getPublishingContractsSubCataloguesWorks },
        isLoading() { return this.$store.getters.getIsLoading },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        numberOfPages() { return this.$store.getters.getNumberOfPages },
        totalRecords() { return this.$store.getters.getTotalRecords },
        currentPage: {
            get() { return this.$store.getters.getCurrentPage },
            set(page) { this.$store.commit('setCurrentPage', page)}
        }
    },
    methods: {
        getPanelHeader(subcatalogue) {
            if(subcatalogue.licensor.group !== null && subcatalogue.licensor.group !== '') return subcatalogue.licensor.group
            else return subcatalogue.licensor.gemaName
        },
        async nextPage() { 
            await this.$store.dispatch('fetchPublishingContractsSubCataloguesWorks', this.subcatalogue.alvId) 
            this.$vuetify.goTo('#listPage')
        },
        onOpenPanel() {
            this.$store.commit('setPublishingContractsSubCataloguesWorksSearch', '')
            this.$store.commit('setPublishingContractsSubCataloguesWorks', [])
            this.$store.dispatch('fetchPublishingContractsSubCataloguesWorks', this.subcatalogue.alvId)
        },
        deleteRow(item) {
            this.$store.commit('setSelectedPublishingContractsSubCatalogues', this.subcatalogue.alvId)
            this.$store.commit("setSelectedWorksForSubCatalogues", item.alvId)
            this.$store.commit('setDeletionDialogContext', 'SelectedWorksForSubCatalogues')
            this.$store.commit('setShowDeletionDialog', true)
        },
    }
}
</script>